module.controller('productRegulationListCtrl', [ '$scope', '$rootScope',
		'$state', 'productService', 'alertService', 'roleService',
		'parameterService', 'regulationService', productRegulationListCtrlFn ]);
function productRegulationListCtrlFn($scope, $rootScope, $state,
		productService, alertService, roleService, parameterService,
		regulationService) {

	$scope.idProduct = $state.params.id;
	$scope.loading = false;
	$scope.loadingSamplingMethods = false;
	$scope.availableTechniques = [];
	$scope.availableAnalysis = [];
	$scope.productSamplingMethods = {};
	$scope.samplingMethod = {};
	$scope.regulation = {};
	$scope.IdRegulation;
	$scope.regulations = {};

	/*
	 * Evento que se ejecuta cuando cambia el selector de la normativa
	 */
	$scope.onSelectRegulation = function(regulation) {
		$scope.IdRegulation = regulation.id;
		searchTechniqueSamplingMethod(regulation.id);

	}

	$scope.sendAction = function() {
		var edit = $scope.isAsociated($scope.regulation.selected.id);
		if (edit) {
			EditAsociationRegulations2Product();
		} else {
			asociateRegulations2Product();
		}
	}

	/*
	 * Desasociar una normativa de un producto
	 */
	$scope.desasociateRegulationForProduct = function(idRegulation) {
		alertService
				.showSwtQuestion(
						'Desasociar normativa a producto',
						function() {
							$scope.loading = true;

							productService
									.desassociateRegulations($scope.idProduct,
											idRegulation)
									.then(
											function(response) {
												loadProductSamplingMethods();
												$scope.regulation = {};
												$scope.availableTechniques = [];
												alertService
														.showSuccess('Normativa desasociada al producto');
												$scope.loading = false;
											}, function(response) {
												$scope.loading = false;
											});
						})

	};

	/*
	 * Editar una regulación
	 */
	$scope.editRegulation = function(regulation) {
		
		$scope.regulation.selected = regulation;
		$scope.IdRegulation = regulation.id;
		searchTechniqueSamplingMethod(regulation.id);
	}

	/*
	 * Está asociada la normativa selecionada
	 */
	$scope.isAsociated = function(idRegulation) {
		if (angular.isUndefined($scope.productSamplingMethods)
				|| !Array.isArray($scope.productSamplingMethods))
			return;
		var getProductSamplingMethods = function(psm) {
			return psm.technique.analysis.regulation.id == this;
		};
		return $scope.productSamplingMethods.some(getProductSamplingMethods,
				idRegulation);
	}

	function Init() {
		loadProductSamplingMethods();
	}

	/*
	 * Se asocia los métodos al producto, que asu vez asocia las tecnicas,
	 * analisis y normativas
	 */
	function asociateRegulations2Product() {

		alertService
				.showSwtQuestion(
						'Asociar normativa a producto',
						function() {
							var Model = [];
							var IdFound;
							$scope.loading = true;
							var ModelComplete = {};
							var getSampleMethod = function(sm) {
								return sm.id
							};

							var getTechnique = function(t) {
								var createModel = new Object();
								var sm = t.samplingMethod.map(getSampleMethod);
								createModel.idAnalysis = t.analysis.id;
								createModel.ids = sm;

								var found = Model.find(function(element) {
									return element.id == t.analysis.id;
								});
								if (found != undefined) {
									found.ids.push(sm[0]);
								} else {
									Model.push(createModel);
								}

							};

							$scope.availableTechniques.forEach(getTechnique);

							ModelComplete.model = Model;
							productService
									.associateRegulations($scope.idProduct,
											$scope.IdRegulation, ModelComplete)
									.then(
											function(response) {
												$scope.loading = false;
												loadProductSamplingMethods();
												$scope.regulation = {};
												$scope.availableTechniques = [];
												alertService
														.showSuccess('Normativas asociadas al producto');
											}, function(response) {
												$scope.loading = false;
											});

						});
	}
	;

	/*
	 * Editar una aosiciacion
	 */
	function EditAsociationRegulations2Product() {

		alertService
				.showSwtQuestion(
						'Editar los métodos aociados a la normativa',
						function() {

							$scope.loading = true;
							var updateModel = {
								ids : []
							};
							var getSampleMethod = function(sm) {
								var samplingMethod = getProductSamplingMethod(sm.id);
								// si no existe entre los elementos de muestreo
								// de producto
								// normativa, se adiciona
								if (angular.isUndefined(samplingMethod))
									updateModel.ids.push("+" + sm.id);
								else
									samplingMethod.check = true;
							};
							var getTechnique = function(t) {
								t.samplingMethod.forEach(getSampleMethod);

							};

							var getNonchecked = function(n) {
								return (angular.isUndefined(n.check) || !n.check)
										&& (n.technique.analysis.regulation.id == this);
							}
							var mapRemoveSamplingMethod = function(r) {
								return "-" + r.id;
							};

							$scope.availableTechniques.forEach(getTechnique);
							var remove = $scope.productSamplingMethods.filter(
									getNonchecked,
									$scope.regulation.selected.id).map(
									mapRemoveSamplingMethod);
							updateModel.ids = updateModel.ids.concat(remove);

							if (updateModel.ids.length == 0) {
								alertService
										.showWarning('No hay cambios para actualizar');
								$scope.loading = false;
								$scope.regulation = {};
								$scope.availableTechniques = [];
								return;
							}
							productService
									.updateAssociateRegulations(
											$scope.idProduct,$scope.IdRegulation, updateModel)
									.then(
											function(response) {
												loadProductSamplingMethods();
												$scope.regulation = {};
												$scope.availableTechniques = [];
												alertService
														.showSuccess('Editar normativas asociadas al producto exitoso');
												$scope.loading = false;
											}, function(response) {
												$scope.loading = false;
											});

						});
	}
	;

	/*
	 * Carga los métodos de Muestreos asociados al producto
	 */
	function loadProductSamplingMethods() {
		$scope.loading = true;
		productService.getRegulationsOfProduct($scope.idProduct).then(
				function(response) {
					$scope.loading = false;
					var result = response.getData();
					$scope.productSamplingMethods = result;
					$scope.regulations = getRegulationsFromSamplingMethod();
				}, function(response) {
					$scope.loading = false;
				});
	}
	;

	/*
	 * Obtiene los Método de la normativa selecionada
	 */
	function searchTechniqueSamplingMethod(idRegulation) {
		$scope.loadingSamplingMethods = true;
		var filter = {
			active : true
		};
		filter["technique.analysis.regulation.active"] = true;
		$scope.availableTechniques = [];
		regulationService.searchAnalysisSamplingMethod(idRegulation, filter)
				.then(function(response) {
					$scope.availableTechniques = response.getData().results;

					$scope.loadingSamplingMethods = false;
					loadProductSamplingMethod();
					loadAnalysis();
				}, function(response) {
					$scope.loadingSamplingMethods = false;
				});
	}

	/*
	 * Obtiene las normativas a partir de la informacion de los métodos de
	 * muestreo
	 */
	function getRegulationsFromSamplingMethod() {
		var regulations = [];

		if (angular.isUndefined($scope.productSamplingMethods)
				|| !Array.isArray($scope.productSamplingMethods))
			return;

		$scope.productSamplingMethods.forEach(function(sm) {
			var id = sm.technique.analysis.regulation.id;
			var exist = regulations.some(function(r) {
				return r.id === id;
			});
			if (!exist) {
				regulations.push(sm.technique.analysis.regulation);
			}
		})

		return regulations;
	}

	/*
	 * se cargan los lementos de muestreo ya sociados a la tecnica
	 */
	function loadProductSamplingMethod() {
		var mapSamplingMethod = function(sm) {
			return {
				id : sm.id,
				name : sm.name,
				uncertainty : sm.uncertainty
			};
		}
		var getProductSamplingMethods = function(sm) {
			return sm.technique.id == this.id;
		};
		var getTechnique = function(t) {
			var psm = $scope.productSamplingMethods.filter(
					getProductSamplingMethods, t);
			t.samplingMethod = psm.map(mapSamplingMethod);
		};
		$scope.availableTechniques.forEach(getTechnique);
	}

	function loadAnalysis() {
		$scope.availableAnalysis = [];

		var compareAnalysis = function(a) {
			return a.id == this;
		}

		var getTechnique = function(t) {
			var idx = $scope.availableAnalysis.findIndex(compareAnalysis,
					t.analysis.id);
			if (idx < 0) {
				var init = {
					id : t.analysis.id,
					name : t.analysis.name,
					techniques : []
				}
				init.techniques.push(t);
				$scope.availableAnalysis.push(init);
			} else {
				$scope.availableAnalysis[idx].techniques.push(t);
			}
		};

		$scope.availableTechniques.forEach(getTechnique);
	}

	function getProductSamplingMethod(idSamplingMethod) {
		var getSM = function(sm) {
			return sm.id == this;
		};
		return $scope.productSamplingMethods.find(getSM, idSamplingMethod);
	}

	Init();
};
